import { SingleSelectOption } from '@/modules/common';
import {
  renderProjectDropdownOption,
  renderProjectDropdownTrigger,
} from '@/modules/projects/helpers/project-dropdown-option';

// Thin wrappers over the shared project dropdown renderer so every project
// single-select shows the color dot + name, an "Archived" badge for archived
// projects, and a scheduled archive/unarchive warning. See project-dropdown-option.
export const renderProjectOption = (option: SingleSelectOption, isSelected?: boolean) =>
  renderProjectDropdownOption(option, { isSelected: !!isSelected });

export const renderProjectTrigger = (
  selectedOption: SingleSelectOption | null,
  placeholder: string
) => renderProjectDropdownTrigger(selectedOption, placeholder);
